import loadable from '@loadable/component';
import stateManager from './state_manager';

const InnovationByDesign2024 = loadable(() => import('./list_page_2024'));
const InnovationByDesign2025 = loadable(() => import('./list_page_2025'));
const InnovationByDesign = loadable(() => import('./list_page'));
const SplashPage = loadable(() => import('./splash_page'));
const SplashPageNew = loadable(() => import('./splash_page_new'));

const innovationByDesignRoute = store => {
  const SPLASH_PAGE_ACTIVE =
    store?.getState()?.franchisePage?.data?.externalList?.metadata?.[0]?.[
      'Show Splash Page'
    ] || false;
  return {
    path: '/innovation-by-design/:year(2024)',
    component: SPLASH_PAGE_ACTIVE ? SplashPage : InnovationByDesign2024,
    exact: true,
    strict: true,
    loadData: stateManager(store)
  };
};

const innovationByDesign2025Route = store => {
  const SPLASH_PAGE_ACTIVE =
    store?.getState()?.franchisePage?.data?.externalList?.metadata?.[0]?.[
      'Show Splash Page'
    ] || false;

  return {
    path: '/innovation-by-design/:year(2025)',
    component: SPLASH_PAGE_ACTIVE ? SplashPage : InnovationByDesign2025,
    exact: true,
    strict: true,
    loadData: stateManager(store)
  };
};

const innovationByDesign2026Route = store => {
  const SPLASH_PAGE_ACTIVE = true;
  return {
    path: '/innovation-by-design/:year(2026|list)',
    component: SPLASH_PAGE_ACTIVE ? SplashPageNew : InnovationByDesign,
    exact: true,
    strict: true,
    loadData: stateManager(store)
  };
};

export {
  innovationByDesignRoute,
  innovationByDesign2025Route,
  innovationByDesign2026Route
};
